import { TFunction } from 'react-i18next';
import { Column } from 'react-table';
import OverflowTooltip from '../../OverflowTooltip/OverflowTooltip';
import EmptyRowContent from '../../DataTable/EmptyRowContent';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DateTimeCell from '../../Calls/DateTimeCell';
import TwoLineCell from '../../Calls/TwoLineCell';

export interface MeasuredServiceTableRowInterface {
    id: string;
    accountId?: string;
    description?: string;
    start?: string;
    end?: string;
    units: number;
    chargedAmount?: number;
    cld: string;
}

export const generateColumns = (
    t: TFunction<string>,
    currency = 'USD',
    userDateTimeFormat?: string,
): Column<MeasuredServiceTableRowInterface>[] => {
    return [
        {
            Header: t<string>('screens:billing.accountID'),
            accessor: 'accountId',
            width: 1,
            Cell: function Cell(params) {
                const text = params.row.original.accountId;

                return (
                    <OverflowTooltip
                        tooltip={text}
                        text={text}
                        dataQa={'account-id-text'}
                        copy={false}
                    />
                );
            },
        },
        {
            Header: t<string>('common:description'),
            accessor: 'description',
            width: 2,
            Cell: function Cell(params) {
                const text = params.row.original.description || '';
                const cld = params.row.original.cld || '';
                return (
                    <TwoLineCell
                        headerText={text}
                        descriptionText={cld}
                    />
                );
            },
        },
        {
            Header: t<string>('common:startDate'),
            accessor: 'start',
            width: 1.1,
            Cell: function Cell(params) {
                return params.row.original.start ? (
                    <DateTimeCell
                        time={params.row.original.start as string}
                        customDateFormat={userDateTimeFormat}
                    />
                ) : (
                    <EmptyRowContent />
                );
            },
        },
        {
            Header: t<string>('common:endDate'),
            accessor: 'end',
            width: 1.1,
            Cell: function Cell(params) {
                return params.row.original.end ? (
                    <DateTimeCell
                        time={params.row.original.end as string}
                        customDateFormat={userDateTimeFormat}
                    />
                ) : (
                    <EmptyRowContent />
                );
            },
        },
        {
            Header: t<string>('screens:billing.units'),
            accessor: 'units',
            width: 0.5,
            Cell: function Cell(params) {
                return params.row.original.units;
            },
        },
        {
            Header: t<string>('screens:billing.chargedWithCurrency', {
                currency: currency,
            }),
            width: 0.7,
            accessor: 'chargedAmount',
            Cell: function Cell(params) {
                return params.row.original.chargedAmount
                    ? params.row.original.chargedAmount.toFixed(2)
                    : Number(0).toFixed(2);
            },
        },
    ];
};

export const useStyles = makeStyles(() => ({
    header: {
        '& th:nth-child(5)': {
            display: ' flex',
            justifyContent: 'end',
        },
        '& th:nth-child(6)': {
            display: ' flex',
            justifyContent: 'end',
        },
        '& th:nth-child(7)': {
            display: ' flex',
            justifyContent: 'end',
        },
    },

    tableContent: {
        '& td': {
            alignItems: 'center !important',
        },
        '& td:nth-child(5)': {
            display: 'flex',
            justifyContent: 'end',
        },
        '& td:nth-child(6)': {
            display: 'flex',
            justifyContent: 'end',
        },
        '& td:nth-child(7)': {
            display: 'flex',
            justifyContent: 'end',
        },
    },
}));
